import React, { useContext } from "react";
import { Box } from '@mui/material';
import { ThemeContext } from 'styled-components';

/**
 * Wrapper component for menu items with icon spacing
 * Ensures consistent left icon space and right spacing for text alignment
 * Similar to WithActions but for menu items (icons are not clickable)
 */
const WithIcons = ({
    // Icon props
    showLeftIcon = false,
    leftIcon,
    leftIconSize = 24,
    leftIconColor,

    // Layout props
    iconWidth = '32px', // Width for both left and right icon spaces
    gap = '0px',

    // Children (the menu item content)
    children
}) => {
    const theme = useContext(ThemeContext);
    const hasIcons = showLeftIcon || true; // Always show spacing for consistency
    const actualIconWidth = hasIcons ? iconWidth : '0px';
    const actualGap = hasIcons ? gap : '0px';
    const actualLeftIconColor = leftIconColor || theme.colors.text;

    return (
        <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            width: '100%', 
            gap: actualGap 
        }}>
            {/* Left Icon Container */}
            <Box sx={{
                width: actualIconWidth,
                minWidth: actualIconWidth,
                maxWidth: actualIconWidth,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
            }}>
                {/* Left Icon */}
                {showLeftIcon && leftIcon && (
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        {React.createElement(leftIcon, {
                            size: leftIconSize,
                            color: actualLeftIconColor,
                        })}
                    </Box>
                )}
            </Box>

            {/* Content Container */}
            <Box sx={{
                flex: 1,
                minWidth: 0,
                display: 'flex',
                alignItems: 'center',
            }}>
                {children}
            </Box>

            {/* Right Icon Container (for symmetry) */}
            <Box sx={{
                width: actualIconWidth,
                minWidth: actualIconWidth,
                maxWidth: actualIconWidth,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
            }}>
                {/* Right side is empty, just for spacing symmetry */}
            </Box>
        </Box>
    );
};

export default WithIcons;
